<ll-titulo>Entradas</ll-titulo>
<blog [perfiles]="perfiles" [external]="external"></blog>
